import React from "react";
import PropTypes from "prop-types";
import { Chip, Grid } from "@mui/material";

function SnippetReportSummaryFilters({ filterMap }) {
  return (
    <Grid container spacing={1}>
      {filterMap?.map((filter, i) => {
        return filter.filterValues.length ? (
          <Grid item key={i}>
            <Grid
              container
              spacing={0.5}
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
            >
              <Grid item>
                <Chip
                  key={filter.filterName + "-" + i}
                  label={
                    <>
                      <b>
                        {filter.filterName}
                        {":"}
                      </b>
                      {filter.filterValues.map((value) => (
                        <Chip
                          variant="outlined"
                          size="small"
                          label={value}
                          key={value}
                          style={{ background: "#eee", marginLeft: "0.5em" }}
                        />
                      ))}
                    </>
                  }
                />
              </Grid>
            </Grid>
          </Grid>
        ) : null;
      })}
    </Grid>
  );
}

SnippetReportSummaryFilters.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.object),
};

export default SnippetReportSummaryFilters;
